<template>
    <v-card class="layout column align-end calendar-modal" @click.native="CHECK_DATE_FOR_VISUAL(false)">
        <closeButton icon_name="close" class="modal-btn" @click.native="close_modal()" />
        <v-layout column pb-4>
            <div class="display-1 pa-4 calender" @click.native="close_modal()">{{$t("Календарь событий")}}</div>

            <!-- <span>{{ calendar_date }}</span> -->
            <div class="datepicker">
                <datepicker ref="calender" :inlined="true" :showInput="false"
                            :has_events="true" @input="click_date($event)"
                            @coordinates = 'coordinates($event, $el)'
                />
                <Tooltip
                    v-if="show_flag"
                    ref="tooltip"
                    :left='tooltip_left'
                    :bottom='tooltip_bottom'
                    :day="day"
                    @el='change_tooltip'
                />
            </div>
        </v-layout>
    </v-card>
</template>

<script>
import CloseButton from '@/components/ui/buttons/buttons_icon/close_button';
import Datepicker from '@/components/ui/inputs/base/datepicker.vue';
import Tooltip from './calendar_tooltip';
import {mapGetters, mapMutations, mapActions} from 'vuex';
// import Vue from 'vue';
import dayjs from 'dayjs';

export default {
  components: {
    Datepicker,
    CloseButton,
    Tooltip,
  },
  props: {
    active: {
      type    : Boolean,
      required: true,
    },
  },
  data() {
    return {
      day           : '',
      coord         : {},
      picker        : new Date().toISOString().substr(0, 10),
      tooltip_height: 0,
      tooltip_width : 400,
      tooltip_bottom: 0,
      tooltip_left  : 0,
    };
  },
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('calendar', ['calendar_dates', 'show_flag', 'calendar_showed']),
  },
  async mounted() {
    document.querySelector('.v-overlay').addEventListener('click', this.close_modal);
    this.get_courses_calendar();
  },
  destroyed() {
    if (document.querySelector('.v-overlay')) {
      document.querySelector('.v-overlay').removeEventListener('click', this.close_modal);
    }
  },
  methods: {
    change_tooltip(elem) {
      this.tooltip_width = elem.offsetWidth;
      this.tooltip_height = elem.offsetHeight;
    },
    coordinates(coord) {
      this.coord = coord;
    },
    ...mapActions('calendar', ['check_date_for_use', 'get_courses_calendar']),
    ...mapMutations('calendar', ['TOGGLE_CALENDAR', 'CLOSE_CALENDAR', 'SET_CALENDAR_DATES', 'CHECK_DATE_FOR_VISUAL', 'RESET_ACTUAL_DATES']),
    click_date(date) {
      this.day = date.target.value.split(' ')[0];
      this.RESET_ACTUAL_DATES();
      this.CHECK_DATE_FOR_VISUAL(false);
      this.check_date_for_use(this.day);

      if (this.day && this.show_flag) {
        const cont_coord = {};
        const el_coord = {};

        cont_coord.top = this.get_ofset(document.querySelectorAll('.datepicker')).top;
        cont_coord.left = this.get_ofset(document.querySelectorAll('.datepicker')).left;

        el_coord.top = this.coord.top;
        el_coord.left = this.coord.left;
        let calendar_coord = document.querySelector('.flatpickr-innerContainer').getBoundingClientRect();
        let coordinates = document.querySelector('.flatpickr-day.selected.has_event').getBoundingClientRect();

        this.tooltip_bottom = calendar_coord.bottom - coordinates.bottom + coordinates.height + 13;
        this.tooltip_left = coordinates.x - calendar_coord.x - (this.tooltip_width / 2) + 10;
      }

      //   if (!this.tooltip_top && !this.tooltip_left) {
      //     setTimeout(()=>{
      //       this.tooltip_top = el_coord.top - cont_coord.top - this.tooltip_height - 30;
      //       this.tooltip_left = el_coord.left - cont_coord.left - this.tooltip_width/2 + 10;
      //     }, 0);
      //   } else {
      //     this.tooltip_top = el_coord.top - cont_coord.top - this.tooltip_height -30;
      //     this.tooltip_left = el_coord.left - cont_coord.left - this.tooltip_width/2 + 10;
      //   }

      // if (!date) {
      //   this.CHECK_DATE_FOR_VISUAL(false);
      // }
      // this.SET_CALENDAR_DATES(date);
    },
    close_modal: function() {
      this.CHECK_DATE_FOR_VISUAL(false);
      // this.$emit('close');
      this.CLOSE_CALENDAR();
      // let elem = document.querySelectorAll('.flatpickr-day.selected.apend');
      // if (elem[0].childNodes[1]) {
      //   elem[0].childNodes[1].remove();
      // }
      // elem.remove();
    },
    get_ofset(el) {
      const rect = el[0].getBoundingClientRect();
      return {
        left: rect.left + window.scrollX,
        top : rect.top + window.scrollY,
      };
    },
  },
};
</script>
